import { render } from "./ClientEditTask.vue?vue&type=template&id=35e12466"
import script from "./ClientEditTask.vue?vue&type=script&lang=js"
export * from "./ClientEditTask.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__